export const options = {
  align: {
    left: "flex-start",
    center: "center",
    right: "flex-end",
  },
  size: {
    icon: {
      small: {
        padding: "13.5px",
        height: "45px",
        fontSize: "14px",
        iconSize: "18px",
      },
      medium: {
        padding: "15px",
        height: "50px",
        fontSize: "16px",
        iconSize: "20px",
      },
      large: {
        padding: "18px",
        height: "58px",
        fontSize: "18px",
        iconSize: "22px",
      },
    },
    text: {
      small: {
        padding: "20px",
        height: "45px",
        fontSize: "14px",
        iconSize: "18px",
      },
      medium: {
        padding: "22px",
        height: "50px",
        fontSize: "16px",
        iconSize: "20px",
      },
      large: {
        padding: "22px",
        height: "58px",
        fontSize: "18px",
        iconSize: "22px",
      },
    },
    textAndIcon: {
      small: {
        padding: "20px",
        height: "45px",
        fontSize: "14px",
        iconSize: "18px",
      },
      medium: {
        padding: "22px",
        height: "50px",
        fontSize: "16px",
        iconSize: "20px",
      },
      large: {
        padding: "22px",
        height: "58px",
        fontSize: "18px",
        iconSize: "22px",
      },
    },
  },
  iconPosition: {
    left: {
      flexFlow: "row",
    },
    right: {
      flexFlow: "row-reverse",
    },
  },
};
